import React, { useEffect } from "react";
import { PageLayout } from "../components/page-layout";
import { getProtectedResource } from "../services/message.service";
import Dashboard from "../components/dashboard";

export const ProtectedPage = () => {
  useEffect(() => {
    const getMessage = async () => {
      await getProtectedResource();
    };

    getMessage();
  }, []);

  return (
    <PageLayout>
      <div className="content-layout">
        <h1 id="page-title" className="content__title">
          Dashboard
        </h1>
        <Dashboard />
      </div>
    </PageLayout>
  );
};
